// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { SvgIcon, SvgIconProps } from '@mui/material';

interface Props extends Omit<SvgIconProps, 'classes'> {
  className?: string;
}

const JobRequestsIcon: React.FC<Props> = (props) => {
  const classes = withStyles.getClasses(props);
  return (
    <SvgIcon className={classes.root} width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g opacity="0.3">
        <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
      </g>
    </SvgIcon>
  );
};

const JobRequestsIconStyled = withStyles(
  JobRequestsIcon, 
  (theme, props) => ({
    "root": {
      color: theme.palette.colors.black,
    }
  })
);

export default JobRequestsIconStyled;